// extracted by mini-css-extract-plugin
module.exports = {"Invalid":"OnHandStatus_Invalid__1GExt","InProgress":"OnHandStatus_InProgress__3VmoJ","Done":"OnHandStatus_Done__3tqWS"};